/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestDetailResponse } from '../model/requestdetailresponse';
import { CustomerSearchInfoResponse } from '../model/clientinfo';
import { Observable, of, throwError } from 'rxjs';
import { RequestUpdateInfo } from '../model/requestupdateinfo';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { catchError } from 'rxjs/operators';
import { ZsdLoggingService } from '../../../../common/zsd-logging.service';

@Injectable()
export class RequestDetailService {
  constructor(public http: HttpClient, public loggerService: ZsdLoggingService) {
  }

  public getRequestDetail(requestNumber: any) {
    return this.http.get<RequestDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/requests/' + requestNumber);
  }

  public updateRequest(requestNumber: number, files: Array<File>, requestUpdateInfo: RequestUpdateInfo) {
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('uploadFile', files[i], files[i].name);
    }
    formData.append('data', JSON.stringify(requestUpdateInfo));

    return this.http.put(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/requests/' + requestNumber, formData);
  }

  findUser(searchTerm: string, offset: number, limit: number): Observable<CustomerSearchInfoResponse> {
    if (!searchTerm) {
      return of();
    }
    searchTerm = unescape(searchTerm);
    let params = new HttpParams();
    params = params.append('searchTerm', searchTerm);
    params = params.append('offset', offset.toString());
    params = params.append('limit', limit.toString());
     return this.http.get<CustomerSearchInfoResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/client/findusers', { params }).
      pipe(catchError((error: Error) => {
        return throwError(error);
      }));
  }

  public increaseSolutionViewCount(requestId: number): Observable<number> {
    return this.http.post<number>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/requests/' + requestId + '/solution/view', null);
}
}
